import { render, staticRenderFns } from "./BlogArticle.vue?vue&type=template&id=762f12d1&scoped=true"
import script from "./BlogArticle.js?vue&type=script&lang=js&external"
export * from "./BlogArticle.js?vue&type=script&lang=js&external"
import style0 from "./BlogArticle.scss?vue&type=style&index=0&id=762f12d1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762f12d1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,NewsletterBanner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NewsletterBanner/NewsletterBanner.vue').default,LatestArticles: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/articles/LatestArticles/LatestArticles.vue').default,RelatedLinks: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/RelatedLinks/RelatedLinks.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
